import store from '@/store';
import {
	SessionCreatedEvent, SessionServiceReadyEvent, IEventAggregationService, ISessionService
} from '@studyportals/student-interfaces';

export class SessionAdapter {
	private eventAggregationService: IEventAggregationService;

	constructor(eventAggregationService: IEventAggregationService) {
		this.eventAggregationService = eventAggregationService;
	}

	public async initialize(): Promise<void> {
		await this.listenForExistingSession();
		this.listenForNewSession();
	}

	private async listenForExistingSession(): Promise<void> {
		this.eventAggregationService.subscribeTo(SessionServiceReadyEvent.EventType, {
			notify: (event: SessionServiceReadyEvent) => {
				void this.checkSession(event.sessionService);
			}
		}, true);
	}

	private listenForNewSession(): void {
		this.eventAggregationService.subscribeTo(SessionCreatedEvent.EventType, {
			notify: () => {
				store.mutations.setLoggedInFlag(true);
			}
		}, true);
	}

	private async checkSession(sessionService: ISessionService): Promise<void> {
		const session = await sessionService.getSession();
		store.mutations.setLoggedInFlag(session !== null);
	}
}
